// extracted by mini-css-extract-plugin
export default {"history":"history-c5Ugd","historyMask":"history-mask-htqAf","historyHeader":"history-header-Zt6pP","historyBody":"history-body-sMG5f"};